import { render, staticRenderFns } from "./UpcomingLocations.vue?vue&type=template&id=3a1ae390&scoped=true&"
import script from "./UpcomingLocations.vue?vue&type=script&lang=js&"
export * from "./UpcomingLocations.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingLocations.vue?vue&type=style&index=0&id=3a1ae390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ae390",
  null
  
)

export default component.exports